import { render, staticRenderFns } from "./TopicItem.vue?vue&type=template&id=14298f28&"
import script from "./TopicItem.vue?vue&type=script&lang=js&"
export * from "./TopicItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports